export function formatNumber(prefix: string | null, number: number) {
  return !prefix || prefix === '' ? String(number) : `${prefix}-${String(number)}`
}
